import { useManagerMissing } from '../../dataHooks/timelineAndRemindersSectionHooks';
import { ValidationTable } from './ValidationTable';

const ManagerMissingValidation = () => {
  const { data: rowData, isLoading } = useManagerMissing();

  return (
    <ValidationTable
      rowData={rowData}
      isLoading={isLoading}
      title="Manager Missing"
      subTitle="These employees will not receive manager review as they do not have a manager"
    />
  );
};

export { ManagerMissingValidation };
